import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "register-page" }
const _hoisted_2 = { class: "register-brand-panel" }
const _hoisted_3 = { class: "brand-content" }
const _hoisted_4 = { class: "brand-app-name" }
const _hoisted_5 = { class: "register-form-panel" }
const _hoisted_6 = { class: "form-wrapper" }
const _hoisted_7 = { class: "mobile-logo" }
const _hoisted_8 = { class: "mobile-logo-title" }
const _hoisted_9 = { class: "form-row-3" }
const _hoisted_10 = { class: "form-row-2" }
const _hoisted_11 = { class: "form-footer mt-8" }
const _hoisted_12 = { class: "success-modal-content" }
const _hoisted_13 = { class: "success-icon-wrapper" }
const _hoisted_14 = { class: "success-icon" }
const _hoisted_15 = { class: "success-messages" }
const _hoisted_16 = { class: "pending-badge" }

import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { CheckCircle, Clock } from 'lucide-vue-next'
import BaseInput from '@/components/ui/BaseInput.vue'
import BaseButton from '@/components/ui/BaseButton.vue'
import BaseModal from '@/components/ui/BaseModal.vue'
import { useRegister } from '@/composables/auth/useRegister'


export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterView',
  setup(__props) {

const router = useRouter()
const appTitle = computed(() => process.env.VUE_APP_TITLE || 'SP Template')
const showSuccessModal = ref(false)

const {
  firstName,
  middleName,
  lastName,
  email,
  phoneNumber,
  address,
  password,
  passwordConfirmation,
  loading,
  error,
  success,
  handleRegister
} = useRegister()

const handleRegisterSubmit = async () => {
  const result = await handleRegister()
  if (result) {
    showSuccessModal.value = true
  }
}

const goToLogin = () => {
  showSuccessModal.value = false
  router.push('/login')
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "brand-bg-shapes" }, [
        _createElementVNode("div", { class: "brand-shape shape-1" }),
        _createElementVNode("div", { class: "brand-shape shape-2" }),
        _createElementVNode("div", { class: "brand-shape shape-3" })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "brand-logo" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "Logo",
            class: "brand-logo-img"
          })
        ], -1)),
        _createElementVNode("p", _hoisted_4, _toDisplayString(appTitle.value), 1),
        _cache[10] || (_cache[10] = _createElementVNode("h1", { class: "brand-title" }, [
          _createTextVNode("Empowering Abilities,"),
          _createElementVNode("br"),
          _createTextVNode("Transforming Lives.")
        ], -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[12] || (_cache[12] = _createElementVNode("img", {
            src: _imports_0,
            alt: "Logo",
            class: "mobile-logo-img"
          }, null, -1)),
          _createElementVNode("h2", _hoisted_8, _toDisplayString(appTitle.value), 1)
        ]),
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "form-header" }, [
          _createElementVNode("h2", { class: "form-title" }, "Create your account"),
          _createElementVNode("p", { class: "form-description" }, "Fill in your details to get started")
        ], -1)),
        _createElementVNode("form", {
          class: "form-body",
          onSubmit: _withModifiers(handleRegisterSubmit, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(BaseInput, {
              modelValue: _unref(firstName),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(firstName) ? (firstName).value = $event : null)),
              label: "First name",
              type: "text",
              placeholder: "John",
              autocomplete: "given-name",
              required: ""
            }, null, 8, ["modelValue"]),
            _createVNode(BaseInput, {
              modelValue: _unref(middleName),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(middleName) ? (middleName).value = $event : null)),
              label: "Middle name",
              type: "text",
              placeholder: "M. (optional)",
              autocomplete: "additional-name"
            }, null, 8, ["modelValue"]),
            _createVNode(BaseInput, {
              modelValue: _unref(lastName),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(lastName) ? (lastName).value = $event : null)),
              label: "Last name",
              type: "text",
              placeholder: "Doe",
              autocomplete: "family-name",
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(BaseInput, {
            modelValue: _unref(email),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(email) ? (email).value = $event : null)),
            label: "Email address",
            type: "email",
            placeholder: "you@example.com",
            autocomplete: "email",
            required: ""
          }, null, 8, ["modelValue"]),
          _createVNode(BaseInput, {
            modelValue: _unref(phoneNumber),
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(phoneNumber) ? (phoneNumber).value = $event : null)),
            label: "Phone number",
            type: "tel",
            placeholder: "+1 (555) 000-0000 (optional)",
            autocomplete: "tel"
          }, null, 8, ["modelValue"]),
          _createVNode(BaseInput, {
            modelValue: _unref(address),
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(address) ? (address).value = $event : null)),
            label: "Address",
            type: "text",
            placeholder: "123 Main St, City, State (optional)",
            autocomplete: "street-address"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(BaseInput, {
              modelValue: _unref(password),
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(password) ? (password).value = $event : null)),
              label: "Password",
              type: "password",
              placeholder: "••••••••",
              autocomplete: "new-password",
              required: ""
            }, null, 8, ["modelValue"]),
            _createVNode(BaseInput, {
              modelValue: _unref(passwordConfirmation),
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(passwordConfirmation) ? (passwordConfirmation).value = $event : null)),
              label: "Confirm password",
              type: "password",
              placeholder: "••••••••",
              autocomplete: "new-password",
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(BaseButton, {
            type: "submit",
            variant: "primary",
            size: "lg",
            loading: _unref(loading),
            fullWidth: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(loading) ? 'Creating account...' : 'Create account'), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ], 32),
        _createElementVNode("p", _hoisted_11, [
          _cache[14] || (_cache[14] = _createTextVNode(" Already have an account? ")),
          _createVNode(_component_router_link, {
            to: "/login",
            class: "form-footer-link"
          }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createTextVNode(" Sign in ")
            ])),
            _: 1,
            __: [13]
          })
        ])
      ])
    ]),
    _createVNode(BaseModal, {
      modelValue: showSuccessModal.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showSuccessModal).value = $event)),
      size: "md",
      "show-close": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", { class: "modal-footer-buttons" }, [
          _createElementVNode("button", {
            type: "button",
            class: "modal-btn modal-btn-ghost",
            onClick: goToLogin
          }, " Cancel "),
          _createElementVNode("button", {
            type: "button",
            class: "modal-btn modal-btn-primary",
            onClick: goToLogin
          }, " Go to Login Now ")
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_unref(CheckCircle), { class: "h-12 w-12" })
            ])
          ]),
          _cache[19] || (_cache[19] = _createElementVNode("h2", { class: "success-title" }, "Registration Successful!", -1)),
          _createElementVNode("div", _hoisted_15, [
            _cache[17] || (_cache[17] = _createElementVNode("p", { class: "success-message-primary" }, " Your account has been created successfully! ", -1)),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_unref(Clock), { class: "h-4 w-4" }),
              _cache[16] || (_cache[16] = _createElementVNode("span", null, "Pending Approval", -1))
            ]),
            _cache[18] || (_cache[18] = _createElementVNode("p", { class: "success-message-secondary" }, " Your account is currently pending approval from an administrator. You will be notified once your account has been approved. ", -1))
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})